export default {
  title: 'Aikataulupoikkeukset',
  fields: {
    status: {
      label: 'Tila',
    },
    date: {
      label: 'Päivämäärä',
    },
    description: {
      label: 'Syy',
    },
    recurring: {
      label: 'Vuosittain toistuva',
    },
    created: {
      label: 'Luotu',
      creator: 'tekijä {{name}}',
    },
    updated: {
      label: 'Päivitetty',
    },
  },
  status: {
    closed: 'Suljettu',
    open: 'Avoinna',
    paused: 'Keskeytetty',
  },
  date: {
    all_day: 'Koko päivä',
    paused_until_rest_of_day: 'Keskeytetty loppupäiväksi',
  },
  buttons: {
    pause_availability: '+ Keskeytä saatavuus',
    close_availability: '+ Sulje saatavuus',
    amend_availability: '+ Muokkaa saatavuutta',
    sync_from_online_shop: 'Synkronoi verkkokaupasta',
    close: 'Sulje',
    delete: 'Poista',
  },
  projects: {
    online_shop: 'Verkkokauppa',
    reservations: 'Varaukset',
    storefront: 'Storefront',
  },
  error_messages: {
    delete_failed: 'Poistaminen epäonnistui. Yritä uudelleen.',
  },
  toasts: {
    sync_success: 'Synkronointi onnistui',
    sync_error: 'Aikataulupoikkeuksien synkronointi verkkokaupasta epäonnistui. Yritä uudelleen.',
  },
};
